import { AxiosError } from 'axios'

import { isForbiddenError, isUnauthorizedError } from '../http/codes'
import { HttpError } from '../http/responses'
import { Logger } from '../logger/log'

class ErrorHandler {
  static handle(error: Error | HttpError | AxiosError | string, ...args: unknown[]): void {
    if (isUnauthorizedError(error as Error) || isForbiddenError(error as Error)) {
      return
    }
    Logger.error(error, ...args)
  }
}

export default ErrorHandler
